import React from "react";
import { ReelMetadata } from "../../types";
import { useCurrentFrame } from "remotion";

interface VelocityTechHeaderProps {
  data: ReelMetadata;
  opacity: number;
  scale: number;
  translateY: number;
}

export const VelocityTechHeader: React.FC<VelocityTechHeaderProps> = ({
  data,
  opacity,
  scale,
  translateY,
}) => {
  const frame = useCurrentFrame();
  const dividerPos = (frame * 5) % 100;
  const gradientMove = (frame * 2) % 200;

  return (
    <div
      style={{
        width: "100%",
        padding: "60px 40px 20px 40px",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        opacity,
        transform: `translateY(${translateY}px) scale(${scale})`,
        zIndex: 20,
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-end",
        }}
      >
        <h1
          style={{
            fontFamily: "'Outfit', sans-serif",
            fontSize: "48px",
            fontWeight: 900,
            margin: 0,
            textTransform: "uppercase",
            lineHeight: 1,
            letterSpacing: "-1px",
            maxWidth: "80%",
            background: `linear-gradient(120deg, #ffffff ${gradientMove - 40}%, #00d4ff ${gradientMove}%, #ffffff ${gradientMove + 40}%)`,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
            backgroundSize: "200% 100%",
          }}
        >
          {data.headline}
        </h1>
        <div
          style={{
            fontFamily: "'Inter', sans-serif",
            fontSize: "14px",
            fontWeight: 800,
            color: "#ccff00",
            border: "2px solid #ccff00",
            padding: "4px 8px",
            borderRadius: "4px",
            letterSpacing: "1px",
            marginBottom: "6px",
          }}
        >
          LIVE
        </div>
      </div>

      {/* Animated Divider */}
      <div style={{ position: "relative", width: "100%", height: "4px", background: "rgba(255,255,255,0.1)" }}>
        <div
          style={{
            position: "absolute",
            left: `${dividerPos}%`,
            top: 0,
            bottom: 0,
            width: "30%",
            background: "linear-gradient(to right, transparent, #00d4ff, transparent)",
            boxShadow: "0 0 10px #00d4ff",
            transform: "translateX(-50%)",
          }}
        />
      </div>
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
